import { z } from 'zod'

export const serviceWaypointLoadSchema = z.object({
  id: z.number().optional(),
  serviceWaypointId: z.number().optional(),
  loadId: z.number().optional(),
})
